<template>
    <Layout>
        <div class="processing">
            <div class="processing-content">
                <Loader />
                <Words
                    v-show="showText"
                    center
                    title
                    class="description"
                >
                    {{ t('views.processing.description') }}
                </Words>
                <Words
                    v-show="showText"
                    contract
                    class="processing-subtitle"
                >
                    <p>{{ t('views.processing.loader') }}</p>
                </Words>
            </div>
        </div>
    </Layout>
</template>

<script lang="ts" setup>
import Layout from '@/components/Layout.vue'
import { useI18n } from '@/composables/i18n'
import Words from 'widget-components/components/Words/Words.vue'
import Loader from '@/components/Loader.vue'
import { onMounted, ref } from 'vue'

const { t } = useI18n()

const showText = ref<boolean>(false)

onMounted(() => {
    setTimeout(() => {
        showText.value = true
    }, 2000)
})
</script>

<style lang="scss" scoped>
.processing {
    height: 100%;
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    &-content {
        text-align: center;
        margin-top: -30px;
    }
}

.description {
    display: block;
    margin-top: 40px;
    margin-bottom: 16px;
}

.icon {
    display: flex;
    font-size: 30px;
    justify-content: center;
    margin: 20px auto;
}

.loader {
    margin: 0 auto;
}

.processing-subtitle {
    font-size: 14px;
}
</style>
